'use strict';

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

///<reference path="../../../typings/tsd.d.ts" />
var agencyRegistration;
(function (agencyRegistration) {
    var settings = {
        tplPath: './app/modules/agency-registration/',
        routeParams: {
            'create': ['cnpj'].join("&")
        }
    };
    angular.module('tools', []);
    angular.module('agencyRegistrationApp', ['ui.router', 'validations', 'ui.mask', 'ngMessages', 'address', 'tools', 'banks', 'branches', 'commonData', 'ngMaterial']).config(routerConfig);
    function routerConfig($locationProvider, $stateProvider, $urlRouterProvider) {
        /*@ngInject*/
        $urlRouterProvider.otherwise('/search');
        $stateProvider.state('search', {
            url: "/search",
            views: {
                "main@": {
                    templateUrl: settings.tplPath + "search/search-agent.html",
                    controller: "SearchController as $search"
                }
            }
        }).state('search.create', {
            url: "/create?" + settings.routeParams.create,
            views: {
                "create@search": {
                    templateUrl: settings.tplPath + "create/create-agent.html",
                    controller: "CreateController as $create"
                },
                "associate@search": {
                    templateUrl: settings.tplPath + "create/associate.html",
                    controller: "AssociateController as $associate"
                }
            }
        }).state('success', {
            url: "/success",
            views: {
                'success@': {
                    templateUrl: settings.tplPath + 'create/success-create.html',
                    controller: function controller($state) {
                        _classCallCheck(this, controller);

                        if ($state.params["agency"]) this.agencyName = $state.params["agency"].companyData.companyName;else $state.go('search');
                    },

                    controllerAs: '$success'
                }
            },
            params: {
                agency: undefined
            }
        });
    }

    var MainController = function (_common$CommonDashboa) {
        _inherits(MainController, _common$CommonDashboa);

        function MainController() {
            _classCallCheck(this, MainController);

            return _possibleConstructorReturn(this, Object.getPrototypeOf(MainController).apply(this, arguments));
        }

        return MainController;
    }(common.CommonDashboardController);

    ;
    angular.module('agencyRegistrationApp').controller('MainController', MainController);
})(agencyRegistration || (agencyRegistration = {}));